import React, { Fragment, useState } from 'react';
import { Image } from '../../../commonComponents';
import { ConfirmationModal } from '../../../modal';

const VirtualMirrorBanner = ({ image, language }) => {
  const [showCamPopUp, setShowCamPopUp] = useState(false);

  const enableCamPopUp = () => {
    setShowCamPopUp(true);
    document.body.classList.add('open');
  };

  const hideCamPopUp = () => {
    setShowCamPopUp(false);
    document.body.classList.remove('open');
  };

  return (
    <Fragment>
      <figure
        className="content--component__home-banner"
        onClick={enableCamPopUp}
      >
        <Image
          className="img-responsive"
          src={image}
          alt=""
        />
      </figure>
      {showCamPopUp && (
        <ConfirmationModal
          notAllow={hideCamPopUp}
          modalType="camera"
        />
      )}
    </Fragment>
  );
};

export default VirtualMirrorBanner;
